const selectBoxTableValueReducer = (state = true, action) => {
  switch (action.type) {
    case "SELECT_TABLE_ITEMS":
      return {
        selectedIds: {
          ...state.selectedIds,
          [action.name]: action.selectedIds
        }
      };
    default:
      return state;
  }
};

export default selectBoxTableValueReducer;
